export default __webpack_public_path__ + "static/media/card5.a0d4901b.jpg";